import * as React from 'react';
import { useAuth } from '@/auth/use-auth';
import type { ApiUser } from '@/api';

export function RoleGuard({
  allow,
  fallback = null,
  children,
}: {
  allow: ApiUser['role'][];
  fallback?: React.ReactNode;
  children: React.ReactNode;
}) {
  const { user } = useAuth();
  if (!user || !allow.includes(user.role)) return <>{fallback}</>;
  return <>{children}</>;
}
